import React, { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// Suppress findDOMNode deprecation warning from ReactQuill
const originalWarn = console.warn;
console.warn = function (...args) {
  if (
    typeof args[0] === "string" &&
    args[0].includes("findDOMNode is deprecated")
  ) {
    return;
  }
  // originalWarn.apply(console, args);
};

// -------------------------------
// Quill Modules & Formats
// -------------------------------

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "indent",
  "color",
  "background",
  "align",
  "link",
  "image",
  "video",
];

// -------------------------------
// Rich Text Editor Component
// -------------------------------

const RichTextEditor = ({
  value,
  onChange,
  placeholder = "Enter text...",
  readOnly = false,
  label = null,
  height = "250px",
  className = "",
}) => {
  const quillRef = useRef(null);

  return (
    <div className={`mb-3 ${className}`}>
      {label && <label className="form-label fw-semibold">{label}</label>}

      {/* Editor Border Wrapper */}
      <div>
        <ReactQuill
          ref={quillRef}
          theme="snow"
          value={value || ""}
          onChange={onChange}
          modules={modules}
          formats={formats}
          placeholder={placeholder}
          readOnly={readOnly}
          // style={{
          //   height: height,
          // }}
          className="auto-grow-editor"
        />
      </div>
    </div>
  );
};

export default RichTextEditor;
